<template>
  <div
    class="fixed pointer-events-none translate-x-[-50%] translate-y-[-50%] z-10"
    :style="{
      top: ui.confetti.top,
      left: ui.confetti.left
    }"
  >
    <ConfettiExplosion v-bind="ui.confetti" />
  </div>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import VueConfetti from 'vue-confetti'

import ConfettiExplosion from '@/components/Confetti/ConfettiExplosion.vue'

Vue.use(VueConfetti)

export default {
  name: 'TheConfetti',

  components: { ConfettiExplosion },

  computed: {
    ...mapState('ui', ['ui'])
  }
}
</script>
